import {
  Box,
  Button,
  Divider,
  OutlinedInput,
  InputLabel,
  IconButton,
  InputAdornment,
  FormControl,
  FormHelperText,
  Grid,
  Select,
  MenuItem,
} from "@mui/material";
import { useCallback, useEffect, useState, useRef } from "react";
import { makeStyles } from "@mui/styles";
import { onlyNumber, rem } from "assets/js/common";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { getCryptoPwd, displayTel, displayBirth } from "assets/js/common";
import { useForm } from "react-hook-form";
import { loadAction } from "redux/reducers/top";
import { dataDrivers } from "dhx-suite";
import { useHistory } from "react-router-dom";
import DrawerComplete from "components/ui/drawer-complete";

const useStyles = makeStyles((theme) => ({
  point: {
    "& .border-top": {
      borderTop: "1px solid #eee",
      padding: 0,
    },
    "& .layout-flex2": {
      paddingBottom: rem(40),
      height: "auto",
      flex: 1,
      "& .layout-footer": {
        marginTop: "auto",
      }
    },
  },
}));

export default function PointPassword(props) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [showPwd, setShowPwd] = useState({
    pwd: false,
    pwdChk: false,
  });

  const {
    register,
    handleSubmit,
    watch,
    control,
    setError,
    clearErrors,
    setValue,
    getValues,
    reset,
    trigger,
    formState: { errors, submitCount },
  } = useForm({
    defaultValue: {
      pwd: "",
      pwdChk: "",
    },
  });

  const onSubmit = async (data) => {
    const pwd = {
      pwd: data.pwd,
    };
    if (data.pwd) {
      await axios
        .post(`api/mb/mypage/modify-point-password`, pwd)
        .then((res) => {
          setOpen(true);
        });
    }
  };

  useEffect(() => {
    dispatch(
      loadAction({ back: true, title: "포인트 비밀번호 변경", menu: false })
    );
  }, []);

  const [open, setOpen] = useState(false);

  window.appBackKeyHandle = () => {
    history.goBack();
  };

  return (
    <main id="main" className={"container nopad " + classes.point}>
      <form onSubmit={handleSubmit(onSubmit)} className="layout-flex2">
        <div className="layout-body join-body">
          <Grid container spacing={1} className="form-group-wrap" mt={9}>
            <Grid item xs={12} md={6}>
              <FormControl variant="outlined">
                <InputLabel shrink>포인트 비밀번호 입력</InputLabel>
                <OutlinedInput
                  id="pwd"
                  inputProps={{
                    maxLength: 4,
                  }}
                  type={showPwd.pwd ? "tel" : "password"}
                  placeholder="포인트 비밀번호 4자리 입력"
                  aria-describedby="error-pw"
                  {...register("pwd", {
                    minLength: 4,
                    maxLength: 4,
                  })}
                  endAdornment={
                    <InputAdornment position="end">
                      {watch("pwd") && (
                        <IconButton
                          aria-label="view"
                          type="button"
                          className={showPwd.pwd ? "btn-view-off" : "btn-view"}
                          onClick={() => {
                            setShowPwd({
                              ...showPwd,
                              pwd: !showPwd.pwd,
                            });
                          }}
                          edge="end"
                        />
                      )}
                    </InputAdornment>
                  }
                />
                {(errors.pwd?.type === "minLength" ||
                  errors.pwd?.type === "maxLength") && (
                  <FormHelperText id="error-pw" className="error">
                    숫자 4자리를 입력해주세요.
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl variant="outlined">
                <InputLabel shrink>포인트 비밀번호 재입력</InputLabel>
                <OutlinedInput
                  id="pwdChk"
                  inputProps={{
                    maxLength: 4,
                  }}
                  type={showPwd.pwdChk ? "tel" : "password"}
                  placeholder="포인트 비밀번호 재입력"
                  aria-describedby="error-pw"
                  {...register("pwdChk", {
                    validate: (val) => {
                      if (getValues("pwd") == val) return true;
                      else return false;
                    },
                  })}
                  endAdornment={
                    <InputAdornment position="end">
                      {watch("pwdChk") && (
                        <IconButton
                          aria-label="view"
                          type="button"
                          className={
                            showPwd.pwdChk ? "btn-view-off" : "btn-view"
                          }
                          onClick={() => {
                            setShowPwd({
                              ...showPwd,
                              pwdChk: !showPwd.pwdChk,
                            });
                          }}
                          edge="end"
                        />
                      )}
                    </InputAdornment>
                  }
                />
                {errors.pwdChk?.type === "validate" && (
                  <FormHelperText id="error-pw" className="error">
                    비밀번호가 일치하지 않습니다.
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
          </Grid>
        </div>

        <div className="layout-footer">
          <div className="layout-link">
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={!watch("pwd") || !watch("pwdChk")}
            >
              변경하기
            </Button>
          </div>
        </div>
      </form>
      <Box className="notice is-bottom border-top">
        <p className="title">
          <i className="ico-noti" />
          유의사항
        </p>
        <ul className="list list-dot color-info font-14">
          <li>
            기본 포인트 비밀번호는 주민번호 앞 4자리로 설정되어있습니다.
            <br />
            ex)1990년 1월 1일 생일자의 비밀번호는 9001
          </li>
        </ul>
      </Box>

      <div>
        <DrawerComplete
          open={open}
          handleDrawerClose={() => history.goBack()}
          text={`포인트 비밀번호가 변경되었습니다.`}
          callback={() => {}}
        />
      </div>
    </main>
  );
}
